const SignUp = ()=>{
    return (
        <div>
            <h1>Laughter. Tears. Thrill. Find it all on Netflix. </h1>
            <h3>Endless Entertainment starts at Rs 149. Cancel Anytime. </h3>
            <h4>Ready to watch? Enter your email to create or restart your membership.</h4>
            <input type="text" placeholder="Email Address" className="bg-opacity-80 text-white"/>
            <button className="text-white font-bold text-2xl">Get Started</button>
        </div>
    )
}

export default SignUp;